import { PieceSlider, PieceDescription, PieceUnorderedList } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const musicListeningPlatformMvp = {
    name: 'Music listening platform MVP',
    slug: 'music-listening-platform-mvp',
    description: 'Startup MVP where users can listen to music while browsing single page application, creating playlist, sharing, upload, follow and more.',
    cover: {
        url: `${PUBLIC_URL}/portfolio/web-media/cover.jpg`,
        license: {
            link: 'http://www.freepik.com',
            text: 'Designed by vectorpocket / Freepik'
        }
    },
    prominentColor: 'rgb(67,19,174)',
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/portfolio/web-media/share.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by rawpixel.com / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/web-media/woman.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/web-media/woman-play.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by rawpixel.com / Freepik'
                    }
                }, {
                    url: `${PUBLIC_URL}/portfolio/web-media/cover.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by vectorpocket / Freepik'
                    }
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Highlights',
            description: 'Frontend & backend written in Javascript (98% isomorphic code).',
        } as PieceDescription,
        {
            type: 'description',
            title: 'Role',
            description: 'Full Stack developer.',
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Main Technologies',
            items: ['React', 'Relay', 'GraphQL', 'Isomorphic JavaScript', 'Node.js', 'Express', 'Sequelize', 'Server Side Rendering', 'Postgres', 'Socket.io', 'Elasticsearch', 'Redis', 'Kue'],
        } as PieceUnorderedList,
    ],
}

export default musicListeningPlatformMvp;


// WEBPACK FOOTER //
// ./src/store/portfolio/music-listening-platform-mvp.tsx